import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import GreenCheck from '../../svg/icons/check.svg';

const IconGreenCheck = (props) => {
  const { height, width } = props;
  return (
    <Icon
      component={GreenCheck}
      height={height}
      name="check"
      width={width}
    />
  );
};

IconGreenCheck.displayName = 'IconGreenCheck';

IconGreenCheck.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};

IconGreenCheck.defaultProps = {
  height: '40',
  width: '40',
};

export default IconGreenCheck;
